import {isTestVisit} from './bite-reading-totals';
// All readers of one public link share these values. No visitor ID, storage or cookie.
const fields=['bs_campaign','bs_content'] as const;
const valid=(value:string|null):value is string=>!!value&&/^[a-z0-9][a-z0-9-]{0,62}[a-z0-9]$/.test(value);
let source:string[]=[];
let fromShared=false;
const counted=new Set<string>();
type Counter={type:'campaign_total';eventId:string;campaigns:string[];stage:'arrival'|'product';day:string;isTest:boolean};
const queue:Counter[]=[];
let draining=false,retry:ReturnType<typeof setTimeout>|undefined;
export function biteCampaignSource() {
  if(typeof window==='undefined')return [];
  const params=new URLSearchParams(window.location.search);
  const current=fields.map(k=>params.get(k)).filter(valid);
  if(current.length)source=[...new Set(current)];
  return [...source];
}
export function withBiteCampaign(href:string):string {
  if(typeof window==='undefined')return href;
  const values=biteCampaignSource();if(!values.length)return href;
  try{
    const url=new URL(href,window.location.href);
    if(url.origin!==window.location.origin)return href;
    if(url.pathname==='/auth/google'||url.pathname==='/auth/apple'){
      const next=url.searchParams.get('next')||'/';
      if(next.startsWith('/')&&!next.startsWith('//'))url.searchParams.set('next',withBiteCampaign(next));
    }else{
      if(url.pathname!=='/'&&!/^\/bite(?:\/|$)/.test(url.pathname))return href;
      if(!valid(url.searchParams.get('bs_campaign')))values.forEach((value,i)=>url.searchParams.set(fields[i],value));
    }
    return url.pathname+url.search+url.hash;
  }catch{return href;}
}
async function flush() {
  if(draining||!queue.length)return;
  draining=true;
  try{
    const event=queue[0];event.isTest=await isTestVisit();
    const response=await fetch('/api/analytics/event',{method:'POST',credentials:'omit',referrerPolicy:'no-referrer',keepalive:true,signal:AbortSignal.timeout(8000),
      headers:{'content-type':'application/json'},body:JSON.stringify({measurement:'bullstory-v1',events:[event]})});
    if(response.ok||[400,409,422].includes(response.status))queue.shift();
  }catch{/* Preserve the same delivery receipt on a temporary failure. */}
  finally{draining=false;if(queue.length)retry=setTimeout(()=>void flush(),3000);}
}
function count(stage:'arrival'|'product') {
  const campaigns=biteCampaignSource(),key=campaigns.join(',')+':'+stage;
  if(!campaigns.length||counted.has(key))return;
  counted.add(key);
  queue.push({type:'campaign_total',eventId:crypto.randomUUID(),campaigns,stage,day:new Date(Date.now()+9*3600000).toISOString().slice(0,10),
    isTest:navigator.webdriver||/^(localhost|127\.0\.0\.1)$/.test(window.location.hostname)});
  void flush();
}
export function startBiteCampaignSource(pathname:string) {
  const values=biteCampaignSource();
  if(!values.length)return ()=>{};
  if(pathname.startsWith('/bite/shared/'))fromShared=true;
  const href=withBiteCampaign(window.location.pathname+window.location.search+window.location.hash);
  if(href!==window.location.pathname+window.location.search+window.location.hash)window.history.replaceState(window.history.state,'',href);
  count('arrival');
  if(fromShared&&!pathname.startsWith('/bite/shared/')){count('product');fromShared=false;}
  const click=(event:MouseEvent)=>{
    const anchor=(event.target as Element|null)?.closest?.('a[href]') as HTMLAnchorElement|null;
    if(anchor)anchor.href=withBiteCampaign(anchor.href);
  };
  const leave=()=>{if(retry)clearTimeout(retry);void flush();};
  document.addEventListener('click',click,true);
  window.addEventListener('pagehide',leave);
  return ()=>{document.removeEventListener('click',click,true);window.removeEventListener('pagehide',leave);};
}
if(typeof window!=='undefined'){biteCampaignSource();fromShared=window.location.pathname.startsWith('/bite/shared/');}
